import React from 'react'
import {Card, CardHeader, Col, Container, Nav,} from "reactstrap";
import Button from "reactstrap/es/Button";
import Row from "reactstrap/es/Row";
import ScheduleCellItem from "./ScheduleCellItem";
import dateHelpers from "../../helpers/DateHelper";
import ClassApiService from "../../api/classes-api-service";
// Strings
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import stringHelpers from "../../helpers/StringHelper";
import lsHelpers from "../../helpers/LsHelper";
import {Redirect} from "react-router-dom";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

const propTypes = {};

let globalDayCounter = 0;

export default class Schedule extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reloadCalendar: true,
            isLoading: false,
            monthShift: 0,
            events: [],
            curDate: null,
            daysInMonth: 0,
            filters: this.props.filters
        };

        console.log(this.props)
    }

    filterClasses(dClasses, teacherData, roomData) {
        let classes = dClasses;
        if ((this.state.filters.teachers !== null || this.state.filters.rooms !== null) && teacherData && teacherData.length > 0) {

            if (this.state.filters.teachers !== null && this.state.filters.teachers.length > 0) {
                const teacherIds = this.state.filters.teachers.map(t => t.id);
                if (teacherIds && teacherIds.length > 0) {
                    classes = dClasses.filter(c => teacherIds.includes(teacherData.find(td => td.c_id === c.id).t))
                }
            }

            if (this.state.filters.rooms !== null && this.state.filters.rooms.length > 0) {
                const roomIds = this.state.filters.rooms.map(t => t.id);
                if (roomIds && roomIds.length > 0) {
                    classes = classes.filter(c => roomIds.includes(roomData.find(td => td.c_id === c.id).r))
                }
            }
        }

        return classes
    }

    componentDidMount() {
        lsHelpers.updateWeekScheduleShift(0);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.updateSchedule == true) {
            this.getCalendar()
        }

        if (nextProps.filters !== this.state.filters) {
            this.setState({filters: nextProps.filters});
        }
    }

    getCalendar(shift = this.state.monthShift) {
        this.setState({isLoading: true, reloadCalendar: false, events: []});

        ClassApiService.calendar(shift)
            .then(res => {
                this.setState({
                    events: res.data,
                    curDate: res.date,
                    daysInMonth: dateHelpers.lastDayOfMonth(new Date(res.date)).getDate(),
                    reloadCalendar: false
                });

                this.setState({isLoading: false})
            })
            .catch((e) => {
                this.props.handleError(e)
            });
    }

    renderDayCell(pos) {
        const posStart = pos * 7;
        const posEnd = posStart + 7;
        const days = this.state.events.slice(posStart, posEnd);
        let diff = 7 - days.length;
        if (diff > 0) {
            for (let i = 0; i < diff; i++) {
                days.push({classes: []})
            }
        }

        return days.map((dayData, index) => {
            var dClasses = dayData.classes.sort((a, b) => dateHelpers.stringTimeToDate(a.start) - dateHelpers.stringTimeToDate(b.start));
            dClasses = this.filterClasses(dClasses, dayData.teachers, dayData.rooms);

            return (
                <Col style={{height: 120, overflowY: 'auto', overflowX: 'hidden', padding: 0}}>
                    {this.canAddCell(dayData.date) &&
                    <>
                        {this.renderDayData(dayData, dClasses, index)}
                    </>
                    }
                </Col>
            )
        })
    }

    render() {
        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            lsHelpers.logout()
            return <Redirect from="*" to="/auth/login"/>
        }

        this.localize();

        if (this.state.reloadCalendar === true) {
            this.getCalendar()
        }

        globalDayCounter = 0;
        return (
            <Col xl="12">
                <Card className="shadow">
                    <CardHeader className="border-1">
                        <Row className="align-items-center">
                            <div className="col col-xl-3">
                                <h3 className="mb-0">{stringHelpers.capitalize(this.monthName())}</h3>
                            </div>
                            <div className="col">
                                <Nav className="justify-content-end" pills>
                                    <Button
                                        onClick={e => this.anotherMonthEvents(e, -1)}
                                        color="default"
                                    >
                                        <span
                                            className="d-none d-md-block">{stringHelpers.capitalize(this.prevMonthName())}</span>
                                        <span className="d-md-none">{"<"}</span>
                                    </Button>
                                    {this.state.monthShift !== 0 &&
                                    <Button
                                        color="secondary"

                                        onClick={e => this.resetShift(e)}

                                    >
                                        <span
                                            className="d-none d-md-block">{stringHelpers.capitalize(commonStrings.cur_month)}</span>
                                        <span className="d-md-none">{"Today"}</span>
                                    </Button>
                                    }
                                    <Button
                                        color="default"
                                        onClick={e => this.anotherMonthEvents(e, 1)}
                                    >
                                        <span
                                            className="d-none d-md-block">{stringHelpers.capitalize(this.nextMonthName())}</span>
                                        <span className="d-md-none">{">"}</span>
                                    </Button>
                                </Nav>
                            </div>
                        </Row>
                    </CardHeader>


                    <Container>
                        <Row>
                            <Col>
                                <h4 style={{textAlign: 'center'}}>
                                    {commonStrings.short_day.mon}
                                </h4>
                            </Col>
                            <Col>
                                <h4 style={{textAlign: 'center'}}>
                                    {commonStrings.short_day.tue}
                                </h4>
                            </Col>
                            <Col>
                                <h4 style={{textAlign: 'center'}}>
                                    {commonStrings.short_day.wed}
                                </h4>
                            </Col>
                            <Col>
                                <h4 style={{textAlign: 'center'}}>
                                    {commonStrings.short_day.thu}
                                </h4>
                            </Col>
                            <Col>
                                <h4 style={{textAlign: 'center'}}>
                                    {commonStrings.short_day.fri}
                                </h4>
                            </Col>
                            <Col>
                                <h4 style={{textAlign: 'center'}}>
                                    {commonStrings.short_day.sat}
                                </h4>
                            </Col>
                            <Col>
                                <h4 style={{textAlign: 'center'}}>
                                    {commonStrings.short_day.sun}
                                </h4>
                            </Col>
                        </Row>
                    </Container>

                    <Container>
                        {Array.from(Array(6).keys()).map((ind) => (
                            <Row
                                className="mt-2">
                                {this.renderDayCell(ind)}
                            </Row>
                        ))}
                    </Container>
                </Card>
            </Col>
        )
    }

    getDayNumber(dayData) {
        if (dayData.date !== "") {
            globalDayCounter += 1;
        }
        return dayData.date !== "" && globalDayCounter <= this.state.daysInMonth && globalDayCounter < 32 ? globalDayCounter : "";
    }

    monthName() {
        if (this.state.curDate != null) {
            return dateHelpers.monthYear(new Date(this.state.curDate))
        } else {
            return ""
        }
    }

    resetShift(e) {
        this.setState(prevState => {
            return {monthShift: 0, reloadCalendar: true}
        });

        e.preventDefault()
    }

    anotherMonthEvents(e, val) {
        e.preventDefault();

        this.setState(prevState => {
            return {monthShift: prevState.monthShift + val, reloadCalendar: true}
        });

        this.props.onShiftChange(val);
    }

    nextMonthName() {
        let date = dateHelpers.addMonth(new Date(this.state.curDate), 1);
        return dateHelpers.monthYear(date)
    }

    prevMonthName() {
        let date = dateHelpers.addMonth(new Date(this.state.curDate), -1);
        return dateHelpers.monthYear(date)
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    canAddCell(date) {
        const res = date !== "" && globalDayCounter < this.state.daysInMonth && globalDayCounter < 31
        return res
    }

    renderDayData(dayData, dClasses, index) {
        return <>
            <div
                style={{textAlign: "center"}}>
                <Button
                    color={dayData.today === true ? "warning" : (dayData.wday === 0 || dayData.wday === 6) ? "primary" : "default"}
                    size="sm"
                    onClick={e => this.props.onDaySelected(e, dayData.date)}
                    style={{
                        paddingStart: 20,
                        marginBottom: 4
                    }}>{this.getDayNumber(dayData)}</Button>
            </div>
            {(dayData.events || []).concat(dayData.reminders || []).concat(dClasses).map(e => {
                return <ScheduleCellItem event={e} className={`col-lg-12`}
                                         key={index + globalDayCounter}
                                         openEvent={this.props.openEvent}
                                         goToClass={this.props.goToClass}/>
            })}
        </>
    }
}

Schedule.propTypes = propTypes;